import { render, staticRenderFns } from "./CreateRequestModal.vue?vue&type=template&id=61468f36&"
import script from "./CreateRequestModal.vue?vue&type=script&lang=js&"
export * from "./CreateRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports